import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { deleteLikeToProduct, getProductLikeFromInfluencer, postLikeToProduct } from "../../api/influencerApi";
import { UserContext } from "../../context/userContext";
import { LikeProductContainer } from "./LikeProductStyled";

export default function LikeProduct({ product }) {

    const navigate = useNavigate();
    const [isFavorite, setIsFavorite] = useState(false);

    const { id, userToken, userType } = useContext(UserContext);

    useEffect(() => {
        if (userType === 'influencer' && id !== null) {

            getProductLikeFromInfluencer({ influencerId: id }).then((response) => {
                const likes = response
                const favorite = likes.some((element) => element.productid
                    === product.id)

                setIsFavorite(favorite)
            })
        }
    }, [id, product])


    const handlerLike = () => {
        setIsFavorite(!isFavorite);
        if (userToken === null) {
            navigate('/signin')
        } else {

            const likeBody = {
                deleted: "0",
                productid: product.id,
                influincrid: id
            }

            if (isFavorite) {
                deleteLikeToProduct({ productId: product.id, influencerId: id }).then((response) => {
                    if (response.status === 204) {
                        setIsFavorite(false)
                    }

                })
            } else {

                postLikeToProduct({ likeBody: likeBody }).then((response) => {
                    if (response.status === 201) {
                        setIsFavorite(true)
                    }
                })
            }
        }
    }


    return (
        <LikeProductContainer onClick={handlerLike}>

            <svg xmlns="http://www.w3.org/2000/svg" width="45.682" height="39.971" viewBox="0 0 45.682 39.971">

                {(isFavorite) ? (<path id="Icon_awesome-heart" data-name="Icon awesome-heart" d="M41.247,4.981C36.357.814,29.086,1.564,24.6,6.194L22.841,8.005,21.083,6.194C16.6,1.564,9.324.814,4.434,4.981A12.811,12.811,0,0,0,3.551,23.53L20.815,41.356a2.8,2.8,0,0,0,4.042,0L42.121,23.53a12.8,12.8,0,0,0-.874-18.549Z" transform="translate(0.001 -2.248)" fill="#FF0000" /* fill="url(#grad1)" */ />) : (<path id="Icon_awesome-heart" data-name="Icon awesome-heart" d="M41.247,4.981C36.357.814,29.086,1.564,24.6,6.194L22.841,8.005,21.083,6.194C16.6,1.564,9.324.814,4.434,4.981A12.811,12.811,0,0,0,3.551,23.53L20.815,41.356a2.8,2.8,0,0,0,4.042,0L42.121,23.53a12.8,12.8,0,0,0-.874-18.549Z" transform="translate(0.001 -2.248)" fill="#fff" />)}

            </svg>

        </LikeProductContainer>
    )
}